import { FunctionComponent } from 'react';
import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import Share from '@/components/atom/icon/Share';
import theme from '@/styles/theme';

interface ShareButtonProps {
  onClick: () => void;
}
const ShareButton: FunctionComponent<ShareButtonProps> = ({ onClick }) => {
  return (
    <ShareButtonWrapper onClick={onClick}>
      <Share color={theme.color.gray900} />
    </ShareButtonWrapper>
  );
};
export default ShareButton;

const ShareButtonWrapper = styled(DefaultButtonStyled)``;
